import { FC } from "react";
import { ICard } from "../../../interfaces";

import frontSideJoker from "../../../assets/cards/joker.svg";
import frontSideEmotional from "../../../assets/cards/emotional.svg";
import frontSideSocial from "../../../assets/cards/social.svg";
import frontSideMental from "../../../assets/cards/mental.svg";
import frontSidePhysical from "../../../assets/cards/physical.svg";

interface ISolutionCardReadOnly {
    cardData: ICard;
    paddingFromTopInVw?: number;
}

const SolutionCardReadOnly: FC<ISolutionCardReadOnly> = ({ cardData, paddingFromTopInVw }) => {
    let paddingfromTop: string ="4.5vw 1.3vw 0 1.3vw";
    if(paddingFromTopInVw){
        paddingfromTop = `${paddingFromTopInVw}vw 1.5vw 0 1.5vw`;
    }

    const getSolutionCardImageBy = () => {
        switch (cardData.type) {
            case "Joker": { return frontSideJoker; }
            case "Emotional": { return frontSideEmotional; }
            case "Relations": { return frontSideSocial; }
            case "Mental": { return frontSideMental; }
            case "Physical": { return frontSidePhysical; }
        }
    }

    return (
        <div className="card_read_only" >
            <img className="front_side_card_read_only_image" src={getSolutionCardImageBy()} alt="front side action" />
            <div className="front_side_card_read_only_content" style={{padding: paddingfromTop}}>
                <p className="front_side_card_read_only_title">{cardData.title}</p>
                <p className="front_side_card_read_only_body">{cardData.description}</p>
            </div>
        </div>
    );
}

export default SolutionCardReadOnly;